import type { AssignmentResult, AssignmentSource } from '@/types/candidates';

export const ASSIGNMENT_SOURCE_LABEL: Record<AssignmentSource, string> = {
  MANUAL: 'Manual',
  CAREER_SITE: 'Career Site',
  SMART_SOURCING: 'Smart Sourcing',
  CV_PARSED: 'CV Parsed',
};

export const ASSIGNMENT_RESULT_LABEL: Record<AssignmentResult, string> = {
  IN_PROGRESS: 'In progress',
  HIRED: 'Hired',
  REJECTED: 'Rejected',
};
